<template>
  <!-- <div class="content"> -->
  <!-- <p  style="color: aliceblue; font-size: 24px;" @click="resize">修改图标大小</p> -->
  <!-- <div> -->
  <!-- <div class="content-text">
                <div style="width: 150px;" v-for="(item, index) of legendList" :key="index" :style="index === 0 || 2 ? 'margin-right: 49px' : ''">
                    <div class="text-top">
                        <div>
                            <img style="margin-right:5px;margin-bottom: 2px;" :src="item.icon" alt="" />
                        </div>
                        <div>{{item.name}}</div>
                        <div class="num" :style="index === 1 ? 'color: #67CBFF;' : index === 2 ? 'color: #67F9B4;' : 'color: #F5B65C;'">
                            {{item.value > 999 ? addComma(item.value) : item.value}}
                        </div>
                    </div>
                    <div class="text-bottom" :style="index === 1 ? 'color: #67CBFF;' : index === 2 ? 'color: #71EAB4;' : 'color: #F1B062;'">
                        {{item.value1}}
                    </div>
                </div>
            </div>  -->
  <!-- @mousewheel.prevent="rollImg($event)" :style="{width:width-6+'px',height:height-6+'px'}" -->
  <!-- </div> -->
  <div class="chart" :id='"graph"+itemId' :ref="'graph'+itemId"></div>
  <!-- </div> -->
</template>
<script>
  import 'echarts-gl';
  // import dot from '@/assets/dot.png'; // 视频预警小图标
  // import dotBlue from '@/assets/dot-blue.png'; // 烟感预警小图标
  // import dotGreen from '@/assets/dot-green.png'; // 地磁预警小图标
  // import dotYellow from '@/assets/dot-yellow.png'; // 门禁预警小图标
  export default {
    data() {
      return {
        disX: 0,
        disY: 0,
        down: false,
        isHover: false,
        moveStart: {},
        option: {},
        translate: {
          x: 0,
          y: 0
        },
        // width:"450px",
        // height: '230px',
        scale: 1,
        // // 图片参数
        scaleZoom: {
          min: 0.8,
          max: 1.5
        },
        // dotIcon: dot,
        imgUrl: "https://iot.yonjie.com/fonts/indexEditorIcon/piebg-3d.png",
        legendList: [{
            name: '视频预警',
            // icon: dot,
            value: 2623,
            value1: '57%',
          },
          {
            name: '烟感预警',
            // icon: dotBlue,
            value: 674,
            value1: '18%',
          },
          {
            name: '地磁预警',
            // icon: dotGreen,
            value: 674,
            value1: '18%',
          },
          {
            name: '门禁预警',
            // icon: dotYellow,
            value: 674,
            value1: '18%',
          }
        ],
      }
    },
    props: {
      width: {
        default: 440,
        type: [Number, String]
      },
      height: {
        default: 320,
        type: [Number, String]
      },
      itemId: {
        default: 0,
        type: [Number, String]
      },
      legend:{
        default:true,
        type:Boolean
      },
      legendTextShow:{
        default:true,
        type:Boolean
      },
    },
    mounted() {
      // this.chart(true)
    },
    // watch:{
    //   width(){
    //     console.log(this.width)
    //   },
    //   height(){
    //     console.log(this.height)
    //   },
    // },
    methods: {
      addComma(a = 0) {
        return a.toString().replace(/(\d{1})/, '$1,')
      },
      // 图片滚动放大
      // rollImg (e) {
      //     let speed = e.wheelDelta/120
      //     if(e.wheelDelta > 0 && this.scale < this.scaleZoom.max) {
      //         this.scale+=0.04*speed
      //         this.$refs.imgDiv.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`
      //         this.$refs.imgDiv.style.transitionDuration = '1000ms'
      //         this.$refs.imgDiv.style.transitionTimingFunction  = 'ease-out'
      //     }else if(e.wheelDelta < 0 && this.scale > this.scaleZoom.min){
      //         this.scale+=0.04*speed
      //         this.$refs.imgDiv.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`
      //         this.$refs.imgDiv.style.transitionDuration = '1000ms'
      //         this.$refs.imgDiv.style.transitionTimingFunction  = 'ease-out'
      //     }
      // },
      resize(width, height) {
        let dom = document.getElementById('graph' + this.itemId)
        if(!dom){return}
        let echart = this.$echarts.getInstanceByDom(dom)
        if (!echart) {
          chart = this.$echarts.init(dom)
        }
        echart.setOption({
          graphic: { // 这个属性可以在饼图内部填充图片,文字等
            type: 'image', //需要填充图片,配置image,如果不需要图片可以配置其他的, text, circle, sector, ring, polygon, polyline, rect, line, bezierCurve, arc, group,
            style: {
              image: 'https://iot.yonjie.com/fonts/indexEditorIcon/piebg-3d.png', //这里添加图片地址
              width: parseInt((width - 6) * 0.9),
              height: parseInt((height - 6) * 0.65),
              x: 0,
              y: 0
            },
            left: "5%", //
            top: '35%', //配置图片居中
          }
        })
        // console.log((width-6)*0.9,(height-6)*0.65,)
        echart.resize({
          width: width - 6,
          height: height - 6
        })
      },
      resetData(data) {
        // console.log(data)
        this.chart(false, data)
      },
      // 动态获取尺寸
      getGraphi() {
        return {
          type: 'image',
          style: {
            image: this.imgUrl, //这里添加图片地址
            width: parseInt((this.width - 6) * 0.9),
            height: parseInt((this.height - 6) * 0.65),
            x: 0,
            y: 0
          },
          left: "5%", //
          top: '35%', //配置图片居中
        }
      },
      // 监听鼠标事件，实现饼图选中效果（单选），近似实现高亮（放大）效果。
      // optionName是防止有多个图表进行定向option传递，单个图表可以不传，默认是opiton
      bindListen(mychart, option) {
        let selectedIndex = ''
        let hoveredIndex = ''
        let that = this
        // 监听点击事件，实现选中效果（单选）
        // mychart.on('click', (params) => {
        // if(!params.seriesIndex){return}
        // // 从 option.series 中读取重新渲染扇形所需的参数，将是否选中取反。
        // const isSelected = option.series[params.seriesIndex]&&!option.series[params.seriesIndex].pieStatus.selected
        // const isHovered = option.series[params.seriesIndex]&&option.series[params.seriesIndex].pieStatus.hovered
        // const k = option.series[params.seriesIndex].pieStatus.k
        // const startRatio =
        // option.series[params.seriesIndex].pieData.startRatio
        // const endRatio =
        // option.series[params.seriesIndex].pieData.endRatio
        // // 如果之前选中过其他扇形，将其取消选中（对 option 更新）
        // if (selectedIndex !== '' && selectedIndex !== params.seriesIndex) {
        //     option.series[
        //     selectedIndex
        // ].parametricEquation = this.getParametricEquation(
        //     option.series[selectedIndex].pieData.startRatio,
        //     option.series[selectedIndex].pieData.endRatio,
        //     false,
        //     false,
        //     k,
        //     option.series[selectedIndex].pieData.value
        // )
        //     option.series[selectedIndex].pieStatus.selected = false
        // }
        // // 对当前点击的扇形，执行选中/取消选中操作（对 option 更新）
        // option.series[
        // params.seriesIndex
        // ].parametricEquation = this.getParametricEquation(
        // startRatio,
        // endRatio,
        // isSelected,
        // isHovered,
        // k,
        // option.series[params.seriesIndex].pieData.value
        // )
        // option.series[params.seriesIndex].pieStatus.selected = isSelected
        // // 如果本次是选中操作，记录上次选中的扇形对应的系列号 seriesIndex
        // selectedIndex = isSelected ? params.seriesIndex : null
        // // 使用更新后的 option，渲染图表
        // mychart.setOption(option)
        // })
        mychart.on('mouseover', (params) => {
          // 准备重新渲染扇形所需的参数
          let isSelected
          let isHovered
          let startRatio
          let endRatio
          let k
          if (hoveredIndex === params.seriesIndex) {
            // 否则进行高亮及必要的取消高亮操作
          } else {
            // 如果当前有高亮的扇形，取消其高亮状态（对 option 更新）
            if (hoveredIndex !== '') {
              // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 false。
              isSelected = option.series[hoveredIndex].pieStatus.selected
              isHovered = false
              startRatio = option.series[hoveredIndex].pieData.startRatio
              endRatio = option.series[hoveredIndex].pieData.endRatio
              k = option.series[hoveredIndex].pieStatus.k
              // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
              option.series[
                hoveredIndex
              ].parametricEquation = this.getParametricEquation(
                startRatio,
                endRatio,
                isSelected,
                isHovered,
                k,
                option.series[hoveredIndex].pieData.value
              )
              option.series[hoveredIndex].pieStatus.hovered = isHovered
              // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
              hoveredIndex = ''
            }
            // 如果触发 mouseover 的扇形不是透明圆环，将其高亮（对 option 更新）
            if (
              params.seriesName !== 'mouseoutSeries' &&
              params.seriesName !== 'pie2d'
            ) {
              if (!option.series[params.seriesIndex]) {
                return
              } else if (option.series[params.seriesIndex].pieStatus === undefined) {
                return
              }
              // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
              isSelected =
                option.series[params.seriesIndex].pieStatus.selected
              isHovered = true
              startRatio =
                option.series[params.seriesIndex].pieData.startRatio
              endRatio = option.series[params.seriesIndex].pieData.endRatio
              k = option.series[params.seriesIndex].pieStatus.k
              // 对当前点击的扇形，执行高亮操作（对 option 更新）
              option.series[
                params.seriesIndex
              ].parametricEquation = this.getParametricEquation(
                startRatio,
                endRatio,
                isSelected,
                isHovered,
                k,
                option.series[params.seriesIndex].pieData.value + 0.8
              )
              option.series[
                params.seriesIndex
              ].pieStatus.hovered = isHovered
              // 记录上次高亮的扇形对应的系列号 seriesIndex
              hoveredIndex = params.seriesIndex
            }
            option.graphi = that.getGraphi()
            // console.log( option.graphi.style.width, option.graphi.style.height)
            // 使用更新后的 option，渲染图表
            mychart.setOption(option)
            // console.log(mychart.getOption())
          }
        })
        // 修正取消高亮失败的 bug
        mychart.on('globalout', () => {
          // console.log('进来')
          // 准备重新渲染扇形所需的参数
          let isSelected
          let isHovered
          let startRatio
          let endRatio
          let k
          if (hoveredIndex !== '') {
            // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
            isSelected = option.series[hoveredIndex].pieStatus.selected
            isHovered = false
            k = option.series[hoveredIndex].pieStatus.k
            startRatio = option.series[hoveredIndex].pieData.startRatio
            endRatio = option.series[hoveredIndex].pieData.endRatio
            // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
            option.series[
              hoveredIndex
            ].parametricEquation = this.getParametricEquation(
              startRatio,
              endRatio,
              isSelected,
              isHovered,
              k,
              option.series[hoveredIndex].pieData.value
            )
            option.series[hoveredIndex].pieStatus.hovered = isHovered
            // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
            hoveredIndex = ''
          }
          // 使用更新后的 option，渲染图表
          option.graphi = that.getGraphi()
          // console.log( option.graphi.style.width, option.graphi.style.height)
          mychart.setOption(option)
        })

      },
      chart(reset, data) {
        let dom = document.getElementById("graph" + this.itemId)
        if(!dom){return}
        let mychart = this.$echarts.getInstanceByDom(dom)
        if (!mychart) {
          mychart = this.$echarts.init(dom)
        }
        let option = this.getPie3D(data, 1.6);
        mychart.resize({
          width: (this.width - 6) + 'px',
          height: (this.height - 6) + 'px'
        })
        mychart.setOption(option, false);
        mychart.off('mouseover')
        mychart.off('globalout')
        // if(bind){
        this.bindListen(mychart, option)
        // }

      },
      // 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
      getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, height) {
        // 计算
        let midRatio = (startRatio + endRatio) / 2;
        let startRadian = startRatio * Math.PI * 2;
        let endRadian = endRatio * Math.PI * 2;
        let midRadian = midRatio * Math.PI * 2;

        // 如果只有一个扇形，则不实现选中效果。
        if (startRatio === 0 && endRatio === 1) {
          isSelected = false;
        }

        // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
        k = typeof k !== 'undefined' ? k : 1 / 3;

        // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
        let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
        let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;

        // 计算高亮效果的放大比例（未高亮，则比例为 1）
        let hoverRate = isHovered ? 1.05 : 1;

        // 返回曲面参数方程
        return {
          u: {
            min: -Math.PI,
            max: Math.PI * 2,
            step: Math.PI / 32
          },

          v: {
            min: 0,
            max: Math.PI * 2,
            step: Math.PI / 20
          },

          x: function(u, v) {
            if (u < startRadian) {
              return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
            }
            if (u > endRadian) {
              return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
            }
            return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
          },

          y: function(u, v) {
            if (u < startRadian) {
              return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
            }
            if (u > endRadian) {
              return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
            }
            return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
          },

          z: function(u, v) {
            if (u < -Math.PI * 0.5) {
              return Math.sin(u);
            }
            if (u > Math.PI * 2.5) {
              return Math.sin(u);
            }
            return Math.sin(v) > 0 ? 1 * height : -1;
            // console.log(Math.sin(v) > 0 ? 1*height : -1,123132)
            // return 0.5
          }
        };
        // console.log('getparams');
      },
      getPie3D(pieData, internalDiameterRatio) {
        let series = [];
        let sumValue = 0;
        let startValue = 0;
        let endValue = 0;
        let legendData = [];
        let k = typeof internalDiameterRatio !== 'undefined' ? (1 - internalDiameterRatio) / (1 +
          internalDiameterRatio) : 1 / 3;

        // 为每一个饼图数据，生成一个 series-surface 配置
        for (let i = 0; i < pieData.length; i++) {

          sumValue += pieData[i].value;

          let seriesItem = {
            name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
            itemStyle: pieData[i].itemStyle,
            type: 'surface',
            parametric: true,
            zlevel: 10,
            wireframe: {
              show: false,
            },
            pieData: pieData[i],
            pieStatus: {
              selected: false,
              hovered: false,
              k: k
            },
          };

          if (typeof pieData[i].itemStyle != 'undefined') {

            let itemStyle = {};

            typeof pieData[i].itemStyle.color != 'undefined' ? itemStyle.color = pieData[i].itemStyle.color : null;
            typeof pieData[i].itemStyle.opacity != 'undefined' ? itemStyle.opacity = pieData[i].itemStyle.opacity :
            null;

            seriesItem.itemStyle = itemStyle;
          }
          series.push(seriesItem);
          // console.log('get3d');
        }

        // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
        // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。

        for (let i = 0; i < series.length; i++) {
          endValue = startValue + series[i].pieData.value;
          // console.log(series[i]);
          series[i].pieData.startRatio = startValue / sumValue + (startValue / sumValue) * 0.008;
          series[i].pieData.endRatio = endValue / sumValue - (startValue / sumValue) * 0.008;
          series[i].parametricEquation = this.getParametricEquation(series[i].pieData.startRatio, series[i].pieData
            .endRatio, false, false, k, series[i].pieData.value);
          startValue = endValue;
        }

        for (const item of this.legendList) {
          legendData.push(item);
        }
        // console.log(this.width,this.height);
        // 准备待返回的配置项，把准备好的 legendData、series 传入。
        let option = {
          color: ['#0d88ca', '#ff9c35', '#f95b3b', '#3372e8', '#674df6', '#b736d2', '#ed4699', '#fa606f', '#4cec75',
            '#15cdc0'
          ],
          tooltip: {
            backgroundColor: 'rgba(0,0,0,0.8)', // 提示框浮层的背景颜色
            borderColor: 'rgba(0,0,0,0.8)', // 提示框浮层的边框颜色。
            axisPointer: {
              type: "line"
            },
            formatter: params => {
              if (params.seriesName !== 'mouseoutSeries') {
                let html = `
                          <p>
                            <span style="display:inline-block;width: 4px;height: 4px;background-color:${params.color};border-radius: 50%;position:relative; top:-2px;"></span>
                            <span style="font-size:12px;color:#AFC0D0;font-weight:400;">${params.seriesName}</span>
                          </p>
                          `
                let text =
                  `<span style="color:${params.color};">${option.series[params.seriesIndex].pieData.realityData}${option.series[params.seriesIndex].pieData.unit||''},  ${Number((option.series[params.seriesIndex].pieData.value*100).toFixed(option.series[params.seriesIndex].pieData.decimal))}%</span>`
                html += text
                return html
                // return `${params.seriesName}<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>${option.series[params.seriesIndex].pieData.value * 100}`;
              }
            },
          },
          graphic: { // 这个属性可以在饼图内部填充图片,文字等
            type: 'image', //需要填充图片,配置image,如果不需要图片可以配置其他的, text, circle, sector, ring, polygon, polyline, rect, line, bezierCurve, arc, group,
            style: {
              image: this.imgUrl, //这里添加图片地址
              width: parseInt((this.width - 6) * 0.9),
              height: parseInt((this.height - 6) * 0.65),
              x: 0,
              y: 0
            },
            left: "5%", //
            top: '35%', //配置图片居中
          },
          legend: {
            // itemWidth: 20,
            // itemHeight: 6,
            // itemGap: 67,
            // top: 10,
            // left: '20%',
            show: this.legend,
            width:"90%",
            height:"40px",
            type: 'scroll',
            orient: 'horizontal',
            pageIconColor:"#A1E2FF",
            pageTextStyle:{
              color:"#A1E2FF"
            },
            textStyle: {
              color: "#AFC0D0"
            },
            icon: 'circle',
            // selectedMode: false,
            // formatter: (name) => {
            //     let value
            //     let value1
            //     this.legendList.forEach(item => {
            //         if (item.name === name) {
            //             value = item.value
            //             value1 = item.value1
            //         }
            //     })
            //     const arr = [
            //         `{name|${name}}{value|${value}}`,
            //         `{value1|${value1}}`
            //     ].join('\n')
            //     return arr
            // },

            //     data: legendData,
            //     // textStyle:{
            //     //     color:'#AFC0D0',
            //     //     fontSize: 16
            //     // }
          },
          xAxis3D: {
            min: -1,
            max: 1
          },
          yAxis3D: {
            min: -1,
            max: 1
          },
          zAxis3D: {
            min: -1,
            max: 1
          },
          grid3D: {
            show: false,
            boxHeight: 20,
            bottom: '50%',
            environment: '',
            axisLabel: {
              margin: 50,
            },
            viewControl: {
              distance: 180,
              alpha: 30,
              beta: 30,
              rotateSensitivity: 0,
              zoomSensitivity: 0,
              projection: 'perspective',
              autoRotate: false,
            },
            postEffect: {
              enable: false,
              // bloom: {
              //     enable: false,
              //     bloomIntensity: 0.1,
              // },
              // SSAO: {
              //     enable: false,
              //     quality: 'medium',
              //     radius: 2
              // },
              // FXAA: {
              //     enable: false
              // }
            }

          },
          series: series
        };
        if(this.legend&&this.legendTextShow==false){
          option.legend.formatter=()=>{
            return ' '
          }
        }else if(this.legend){
          option.legend.formatter='{name}'
        }
        return option;
      },
    }
  }
</script>
<style scoped>
  .content {
    /* height: 500px; */
    /* background: black; */
    /* position: relative; */
    width: 100%;
    height: 100%;
  }

  .echarts-img {
    position: fixed;
    margin-top: -340px;
    margin-left: 137px;
    /* position: absolute;
        left: 15%;
        top: 45%; */
  }

  .chart {
    /* background: url('https://iot.yonjie.com/fonts/indexEditorIcon/piebg-3d.png') no-repeat;
      background-size: 70% 60%;
      background-position: 50% 95%; */
    width: calc(100% - 6px);
    height: calc(100% - 6px);
  }

  .content-text {
    padding-left: 49px;
    width: 500px;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    /* align-items: center; */
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #AFC0D0;
  }

  .content-text .num {
    margin-left: 10px;
    font-size: 20px;
    font-family: YSBTH;
    color: #0FDADA;
    background: linear-gradient(0deg, #50C5C5 0%, #0FDADA 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .text-top {
    display: flex;
  }

  .text-bottom {
    margin-left: 50px;
    text-align: center;
    font-size: 16px;
    margin-bottom: 31px;
    font-family: YSBTH;
  }

  .echarts-img:hover {
    transform-origin: 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/preview/pie3d.vue